<template>
  <div class="home">
    <ImageSlider></ImageSlider>

    <div class="container infos-section text-center">
      <div class="row">        
        <div class="col-12 col-sm-12 col-md-4 col-4">
          <!-- <img src="" class="img-fluid ${3|rounded-top,rounded-right,rounded-bottom,rounded-left,rounded-circle,|}" alt=""> -->
          <div class="infos-icon"><span><i class="fas fa-check-circle"></i></span></div>
          <h2>Une sélection hors pair</h2>
          <p class="lead">Découvrez sur notre site les meilleurs offres du marché adapté a vos envies.</p>
        </div>
        <div class="col-12 col-sm-12 col-md-4 col-4">
          <!-- <img src="" class="img-fluid ${3|rounded-top,rounded-right,rounded-bottom,rounded-left,rounded-circle,|}" alt=""> -->
          <div class="infos-icon"><span><i class="fas fa-smile-beam"></i></span></div>
          <h2>Une équipe dynamique</h2>
          <p class="lead">Nous regroupons des collaborateurs dynamiques qui sont saurons vous conseiller sur la destination qui vous correspond.</p>
        </div>
        <div class="col-12 col-sm-12 col-md-4 col-4">
          <!-- <img src="" class="img-fluid ${3|rounded-top,rounded-right,rounded-bottom,rounded-left,rounded-circle,|}" alt=""> -->
          <div class="infos-icon"><span><i class="fas fa-bookmark"></i></span></div>
          <h2>Un label authentique</h2>
          <p class="lead">Silver trip est recommandé par de nombreux utilisateurs.</p>
        </div>
      </div>
    </div>

    <div class="trip-section">
      
      <div class="container">
        <div>
          <h3 class="trip-title text-center">LES COUPS DE COEUR DU MOMENT</h3>
          <hr class="featurette-divider">
        </div>
        <div class="row card-box">
          <div class="col-12 col-sm-12 col-md-4 col-4">
            <div class="card">
              <img class="card-img-top" height="190" src="../assets/images/champ.jpg" alt="Card image cap">
              <div class="card-body">
                <h4 class="card-title">Champs-Élysées </h4>
                <!-- <p class="card-text">This is a longer card with supporting text below as a natural lead-in to additional content.</p> -->
                <!-- <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p> -->
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-4 col-4">
            <div class="card">
              <img class="card-img-top" height="190" src="../assets/images/eiffel.jpg" alt="Card image cap">
              <div class="card-body">
                <h4 class="card-title">Tour Eiffel</h4>
                <!-- <p class="card-text">This is a longer card with supporting text below as a natural lead-in to additional content.</p> -->
                <!-- <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p> -->
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-4 col-4">
            <div class="card">
              <img class="card-img-top" height="190" src="../assets/images/louvre.jpg" alt="Card image cap">
              <div class="card-body">
                <h4 class="card-title">Musée du Louvre</h4>
                <!-- <p class="card-text">This is a longer card with supporting text below as a natural lead-in to additional content.</p> -->
                <!-- <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p> -->
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </div>

    <div class="infos-section">
      <div class="container">
        <div class="row featurette">
          <div class="col-md-7 my-auto">
            <h2 class="featurette-heading">Une petite ballade en forêt urbaine ?</h2>
            <!-- <p class="lead">Donec ullamcorper nulla non metus auctor fringilla. Vestibulum id ligula porta felis euismod semper. Praesent commodo cursus magna, vel scelerisque nisl consectetur. Fusce dapibus, tellus ac cursus commodo.</p> -->
          </div>
          <div class="col-md-5">
            <img class="featurette-image img-fluid mx-auto" data-src="holder.js/500x500/auto" alt="500x500" src="../assets/images/foret.jpg" data-holder-rendered="true">
          </div>
        </div>
      </div>
    </div>

    <div class="trip-section">
      <div class="container">
        <div class="row featurette">
          <div class="col-md-7 my-auto order-md-2">
            <h2 class="featurette-heading">😍 Redécouvrez votre ville. <span class="text-muted"></span></h2>
            <!-- <p class="lead">Donec ullamcorper nulla non metus auctor fringilla. Vestibulum id ligula porta felis euismod semper. Praesent commodo cursus magna, vel scelerisque nisl consectetur. Fusce dapibus, tellus ac cursus commodo.</p> -->
          </div>
          <div class="col-md-5 order-md-1">
            <img class="featurette-image img-fluid mx-auto" data-src="holder.js/500x500/auto" alt="500x500" src="../assets/images/paris.jpg" data-holder-rendered="true" >
          </div>
        </div>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<style lang="scss">
  .trip-section .card {
    border: none;
  }
  .infos-section {
    padding: 140px 0 140px 0;
  }
  .infos-icon {
    // color: #fab549c7;
    color: #eeb60fcf;
    font-size: 100px;
    margin-bottom: 35px;
  }
  .trip-section {
    padding: 140px 0 140px 0;
    background-color: rgb(248, 248, 248);
  }
  .card-box {
    padding: 35px 0 35px 0;
  }
  .trip-title {
    margin: 0 0 25px 0;
  }
</style>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import ImageSlider from '@/components/ImageSlider.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Home',
  components: {
    // HelloWorld,
    ImageSlider,
    Footer
  }
}
</script>
